import {ApiMethods, ApiServiceController, IApiExecutor} from "../../../../../@bizkeytech";
import ApiEndpoints from "../../endpoints";
import * as models from "./index.types";

/**@inheritDoc*/
export class SettingController extends ApiServiceController {

    /**@inheritDoc*/
    public constructor(executor: IApiExecutor | undefined) {
        super(executor);
    }

    /**
     * Get the configuration of the site from the server.
     *
     * @param abortController       The abort controller that will be used to cancel the request.
     */
    public async getPartnerSetting(abortController?: AbortController): models.GetPartnerSettingResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.setting.getPartnerSetting,
            signal: abortController?.signal,
            showErrorToast: false,
        });
    }

    /**
     * Get the configuration of the site from the server.
     *
     * @param authorizationToken    The token that will be used to authenticate the request.
     * @param abortController       The abort controller that will be used to cancel the request.
     */
    public async getPartnerColorTheme(authorizationToken: string, abortController?: AbortController): models.GetPartnerSettingResponse {
        return this.executor?.execute({
            method: ApiMethods.get,
            url: ApiEndpoints.setting.getPartnerSetting,
            signal: abortController?.signal,
            headers: {
                Authorization: authorizationToken,
            },
        });
    }

}

export * from './index.types';
export default SettingController;
